import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

class ConnectingWorld extends Component {
  render() {
    return (
      <div className="connecting-world">

        <div className="text-container">

          <Fade right>
          <h2>Connecting the world</h2>
          <h3>From its inception, our mission has been to build a beautiful human intelligence product that people love to use. We aim to connect people by creating an identification system that is based on trust, reputation and verification. A global ID that puts people together for the purpose of getting things done.</h3>
          </Fade>

        </div>

      </div>
    );
  }
}

export default ConnectingWorld;



// WEBPACK FOOTER //
// ./src/assets/components/connectingWorld.js